import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=6fe48fa1&scoped=true"
import script from "./svg-icon.vue?vue&type=script&lang=js"
export * from "./svg-icon.vue?vue&type=script&lang=js"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=6fe48fa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe48fa1",
  null
  
)

export default component.exports